import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import Layout from '@/components/ui/Layout.vue';

import Login from './components/login/Login.vue';

import Dashboard from './views/Dashboard.vue';
import Products from './views/Products.vue';
import Users from './views/UsersV2.vue';
import Prices from './views/Prices.vue';
import ProductStatics from './views/ProductStatics.vue';
import ListConfig from './views/ListConfig.vue';
import PercentagesByPriceRange from './views/PercentagesByPriceRange.vue';
import Client from './views/Client.vue';
import PurcharseOrder from './views/PurcharseOrder.vue';
import Images from './views/Images.vue';
import Routes from './views/Routes.vue';
import Route from './views/Route.vue';
import Batch from './views/Batch.vue';
import Bag from './views/Bag.vue';
import Graph from './views/Graph.vue';
import PriceHistory from './views/PriceHistory.vue';
import Maker from './views/Maker.vue';
import Expenses from './views/Expenses.vue';
import BatchesDashboard from './views/BatchesDashboard.vue';
import RoutesDashboard from './views/RoutesDashboard.vue';

Vue.use(Router);

/**
 * If the user is not  authenticated continue to the request else go
 * to the home page;
 */

const ifNotAuthenticated = (to: any, from: any, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

/**
 * If the user is authenticated continue to the request else go
 * to the login page;
 */
const ifAuthenticated = (to: any, from: any, next) => {
  if (store.getters.isAuthenticated) {
    const profile = store.getters.getProfile;
    let home = null;
    if (to.fullPath === '/') {
      home = profile.home;
    }
    if (Object.keys(profile).length > 0) {
      if (home) {
        next(home);
      } else {
        next();
      }
    } else {
      store.dispatch('AUTH_LOGOUT');
      next('/login');
    }
    return;
  }
  next('/login');
};

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'index',
      component: Login,
      // Allow if not authenticated
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/',
      component: Layout,
      // Allow if authenticated
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/users',
          name: 'users',
          component: Users,
        },
        {
          path: '/products',
          name: 'products',
          component: Products,
        },
        {
          path: '/prices',
          name: 'prices',
          component: Prices,
        },
        {
          path: '/productConfig',
          name: 'productConfig',
          component: ProductStatics,
        },
        {
          path: '/listConfig',
          name: 'listConfig',
          component: ListConfig,
        },
        {
          path: '/factors',
          name: 'factors',
          component: PercentagesByPriceRange,
        },
        {
          path: '/routes',
          name: 'routes',
          component: Routes,
        },
        {
          path: '/client',
          name: 'client',
          component: Client,
        },
        {
          path: '/purcharseOrder',
          name: 'purcharseOrder',
          component: PurcharseOrder,
        },
        {
          path: '/images',
          name: 'images',
          component: Images,
        },
        {
          path: '/batch',
          name: 'batch',
          component: Batch,
        },

        {
          path: '/batch/:id',
          name: 'batch',
          component: Batch,
        },
        {
          path: '/bag/:id',
          name: 'bag',
          component: Bag,
        },
        {
          path: '/batch/:idBatch/bag/:idBag/route/:idRoute',
          name: 'route',
          component: Route,
        },
        {
          path: '/graph',
          name: 'graph',
          component: Graph,
        },
        {
          path: '/priceHistory',
          name: 'priceHistory',
          component: PriceHistory,
        },
        {
          path: '/maker',
          name: 'maker',
          component: Maker,
        },
        {
          path: '/expenses',
          name: 'expenses',
          component: Expenses,
        },
        {
          path: '/batches',
          name: 'batches',
          component: BatchesDashboard,
        },
        {
          path: '/batch/:idBatch/routes',
          name: 'routesList',
          component: RoutesDashboard,
        },
      ],
    },
    {
      path: '/userasd',
      name: 'userasd',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        import(/* webpackChunkName: 'dashboard' */ './views/Dashboard.vue');
      },
    },
  ],
});

export default router;
